import moment from "moment";
import { CONTENT_REDIRECT_OPTIONS, PRICE_PER_DAY } from "./adManagementFormConfig";
import { MODE } from "../../constants/common";

export const formatCurrency = (amount) => `$ ${Number(amount).toFixed(2)}`;

export function readFileAsDataUrl(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(file);
  });
}

export function updateDeviceValue(previousValues, device, value) {
  return { ...previousValues, [device]: value };
}

export function getModeFlags(mode) {
  return {
    isViewMode: mode === MODE.VIEW,
    isEditMode: mode === MODE.EDIT,
    isAddMode: mode === MODE.ADD,
  };
}

export function getCurrentUserName(auth) {
  const currentUser = auth.getCurrentUser();
  if (!currentUser) return "Admin";
  return `${currentUser.firstName ?? ""} ${currentUser.lastName ?? ""}`.trim() || "Admin";
}

export function getExistingRecord(record) {
  return record ?? null;
}

export function getFormikInitialValues(existingRecord) {
  return {
    bannerName: existingRecord?.bannerName ?? "",
    position: existingRecord?.position ?? "",
    startDate: existingRecord?.startDate ? moment(existingRecord.startDate, "MM/DD/YYYY") : null,
    endDate: existingRecord?.endDate ? moment(existingRecord.endDate, "MM/DD/YYYY") : null,
    targetDevices: existingRecord?.targetDevices ?? [],
    contentRedirect: existingRecord?.contentRedirect ?? "",
  };
}

export function getPageTitle({ isViewMode, isEditMode }) {
  if (isViewMode) return "View Ad";
  if (isEditMode) return "Edit Ad";
  return "Add Ad";
}

export function getContentRedirectLabel(contentRedirect) {
  return CONTENT_REDIRECT_OPTIONS.find((option) => option.value === contentRedirect)?.label ?? "";
}

export function calcEstimatedCost(startDate, endDate, position, targetingMultiplier) {
  if (!startDate || !endDate || !position) return 0;
  const days = Math.max(1, moment(endDate).diff(moment(startDate), "days") + 1);
  return days * (PRICE_PER_DAY[position] ?? 0) * targetingMultiplier;
}

export function calcRemainingDays(startDate, endDate, isAddMode) {
  if (!endDate) return 0;
  if (isAddMode && startDate) {
    return Math.max(1, moment(endDate).diff(moment(startDate), "days") + 1);
  }
  return Math.max(0, moment(endDate).diff(moment(), "days") + 1);
}
